<mat-card class="schedule-settings-container app-settings-container">
    <mat-card-title>Settings</mat-card-title>

    <mat-tab-group mat-stretch-tabs="false">
        <mat-tab label="Threads Scheduler">
            <app-threads-scheduler-settings [settings]="settings"
                class="threads-scheduler-container"></app-threads-scheduler-settings>
        </mat-tab>

        <mat-tab label="Jobs Scheduler">
            <app-scheduler-settings [hideHeader]="true" [settings]="settings"
                [useOuterSetting]="true"></app-scheduler-settings>
        </mat-tab>

        <mat-tab label="Stuck Threads Checker">
            <app-stuck-treads-checker-settings [settings]="settings"
                class="threads-scheduler-container"></app-stuck-treads-checker-settings>
        </mat-tab>

        <mat-tab label="Garbage Collector">
            <app-garbage-collector-sheduler-settings [settings]="settings"
                class="threads-scheduler-container"></app-garbage-collector-sheduler-settings>
        </mat-tab>
    </mat-tab-group>
    <app-spinner *ngIf="showSpinner" [isInternal]="true"></app-spinner>
</mat-card>